import { SimpleTreeItemWrapper } from 'dnd-kit-sortable-tree';
import { forwardRef, ReactNode } from 'react';
import { Loading } from 'components/uikit/suspense/Loading.tsx';
import styles from '../DocumentListItem.module.scss';
import { DocumentTreeItemProps } from './types.ts';

type TreeItemShellProps = {
  treeProps: DocumentTreeItemProps;
  isLoading: boolean;
  onClick?: () => void;
  children: ReactNode;
  modals?: ReactNode;
};

/** Shell component for rendering a tree item with optional loading state and modals. */
export const TreeItemShell = forwardRef<HTMLDivElement, TreeItemShellProps>(
  ({ treeProps, isLoading, onClick, children, modals }, ref) => (
    <div
      data-test-id="list-item"
      className={styles.mainContainer}
      onClick={onClick}
    >
      <Loading loading={isLoading} wrapperClassName={styles.loader}>
        <SimpleTreeItemWrapper
          {...treeProps}
          showDragHandle={false}
          manualDrag={true}
          ref={ref}
          key={treeProps.item.id}
          indentationWidth={28}
        >
          {children}
        </SimpleTreeItemWrapper>
      </Loading>
      {modals}
    </div>
  ),
);
